var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImageDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#222222",
    fillOpacity: 0.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6402 19.96L15.1802 14.48L20.6402 9L19.6802 8.04L14.2002 13.52L8.7402 8.04L7.7602 9.02L13.2402 14.48L7.7602 19.96L8.7402 20.92L14.2002 15.44L19.6802 20.92L20.6402 19.96Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageDelete);
export default __webpack_public_path__ + "static/media/icon_image_delete.13bfd757cdb44ecf0de3a75d84a1317c.svg";
export { ForwardRef as ReactComponent };